import { useEffect, useState, useCallback } from 'react';
import * as Sentry from '@sentry/react';
import { supabase } from '@/lib/supabaseClient';

export function useClientVouchers(usuarioId?: string | null) {
  const [vouchers, setVouchers] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchVouchers = useCallback(async () => {
    if (!usuarioId) return;
    setLoading(true);

    const { data, error } = await supabase
      .from('vista_bonos_comprados')
      .select('*')
      .eq('id_usuario', usuarioId)
      .order('fecha_compra', { ascending: false });

    if (error) {
      Sentry.captureException(error, { extra: { usuarioId } }); // 👈
      setVouchers([]);
    } else {
      setVouchers(data || []);
    }

    setLoading(false);
  }, [usuarioId]);

  useEffect(() => {
    fetchVouchers();
  }, [fetchVouchers]);

  return { vouchers, loading, refetch: fetchVouchers };
}
